import styled from 'styled-components';

export const CanopyLayout = styled.section`
  display: grid;
  position: relative;
  grid-template-columns: 325px 1fr;

`;